import { useMutation } from "@tanstack/react-query";
import { userService } from "@/services/userService";

// mutation keys
export const usersMutationKeys = {
    all: ['users'],
    create: () => [...usersMutationKeys.all, 'create'],
    update: () => [...usersMutationKeys.all, 'update'],
    delete: () => [...usersMutationKeys.all, 'delete'],
}

// create user      
export const useCreateUser = () => {
    return useMutation({
        mutationKey: usersMutationKeys.create(),
        mutationFn: (userData) => userService.createUser(userData),
    })
}

// delete user
export const useDeleteUser = () => {
    return useMutation({
        mutationKey: usersMutationKeys.delete(),
        mutationFn: (id) => userService.deleteUser(id),
    })
}

export const useUpdateUser = () => {
    return useMutation({
        mutationKey: usersMutationKeys.update(),
        mutationFn: ({ id, userData }) => userService.updateUser(id, userData),
    })
}
